import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children, requireLeader, requireAdmin }) => {
  const token = localStorage.getItem('token');
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  
  if (requireAdmin && user.role !== 'admin') {
    return <Navigate to="/" replace />;
  }
  
  // 支持 isLeader 属性判断审批权限（包括被授权者）
  const isLeader = user.role === 'designer_leader' || user.role === 'admin' || user.isLeader === true;
  if (requireLeader && !isLeader) {
    return <Navigate to="/" replace />;
  }
  
  return children;
};

export default ProtectedRoute;